/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { change, reduxForm, reset, submit } from 'redux-form';
import { useLocation } from 'react-router';
import { ModalWindow } from '../../../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { validate } from './utils';
import { FORM_NAME } from './constants';
import { CreateReqModalForm } from './create-req-modal-form';
import { removeModalQuery } from '../../../../utils/removeModalQuery';
import { getIsLoadingSelector, getIsModesLoadingSelector } from '../../selectors';
import {
	getCategoriesAction,
	getTenderCompaniesAction,
	getTenderTypesAction,
	getTypesAction,
	orderCreateReqAction,
} from './actions';
import {
	getCategoriesSelector,
	getFormInitialValuesSelector,
	getIsCategoriesLoadingSelector,
	getIsMyCarrierSelectedSelector,
	getIsTenderCompaniesLoadingSelector,
	getIsTenderTypesLoadingSelector,
	getIsTypesLoadingSelector,
	getModesOptionsSelector,
	getTenderCompaniesSelector,
	getTenderTypesSelector,
	getTypesSelector,
} from './selectors';
import { useInjectSaga } from '../../../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../../../utils/injectReducer';
import reducer from './reducer';

const CreateReqModalWrapper = ({
	onFormSubmit,
	onResetForm,
	onCreateReq,
	onGetCategories,
	onGetTenderTypes,
	onGetTenderCompanies,
	onGetTypes,
	isLoading,
	categories,
	isCategoriesLoading,
	tenderTypes,
	isTenderTypesLoading,
	tenderCompanies,
	isTenderCompaniesLoading,
	types,
	isTypesLoading,
	modes,
	isModesLoading,
	isModalShown,
	setIsModalShown,
	orders,
	collection,
	group,
	group_way,
	way,
	isMyCarrierSelected,
	onChangeField,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'orderGroupsCreateReqContainerSaga', saga });
	useInjectReducer({ key: 'orderGroupsCreateReqContainerReducer', reducer });

	const { search } = useLocation();

	const query = new URLSearchParams(search);

	let isVisibleFetchAt = true;

	if (way && way.planning) {
		isVisibleFetchAt = false;
	}

	useEffect(() => {
		if (isModalShown) {
			onGetCategories();
			onGetTenderTypes();
			onGetTenderCompanies();
			onGetTypes();

			if (way || group) {
				if (way && way.fetch_at && !way.planning) {
					onChangeField(FORM_NAME, 'fetch_at', way.fetch_at);
				}

				if (way && way.fetch_time_from && !way.planning) {
					onChangeField(FORM_NAME, 'fetch_time_from', way.fetch_time_from);
				}

				if (way && way.fetch_time_to && !way.planning) {
					onChangeField(FORM_NAME, 'fetch_time_to', way.fetch_time_to);
				}

				if (way && way.mode_id) {
					onChangeField(FORM_NAME, 'mode_id', way.mode_id);
				}

				if (way && way.orders_sum_cost) {
					onChangeField(FORM_NAME, 'cost', way.orders_sum_cost);
				}

				if (group && group.orders_sum_cost) {
					onChangeField(FORM_NAME, 'cost', group.orders_sum_cost);
				}
			}
		}
	}, [isModalShown]);

	const [tenderTypesList, setTenderTypes] = useState(tenderTypes);

	useEffect(() => {
		setTenderTypes(tenderTypes);
	}, [isTenderTypesLoading, tenderTypes]);

	const handleModalCancel = () => {
		setIsModalShown(false);
		onResetForm(FORM_NAME);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);

		onCreateReq({
			searchQuery: removeModalQuery(query.toString()),
			orders,
			collection,
			group,
			group_way,
			way,
			callback: handleModalCancel,
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	const handleChangeCategory = categoryId => {
		if (categoryId === 1 || categoryId === 4) {
			setTenderTypes(tenderTypes.filter(el => el.key !== 7));
			onChangeField(FORM_NAME, 'tender_type_id', null);
		} else {
			setTenderTypes(tenderTypes);
		}
	};

	const handleChangeTenderType = () => {
		onChangeField(FORM_NAME, 'tender_tk_id', null);
		onChangeField(FORM_NAME, 'tender_amount', null);
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onClose={handleModalCancel}
			onKeyDown={handleKeyDown}
			headerText="Создать заявку"
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalCancel, text: 'create_req' }]}
			modalContent={
				<CreateReqModalForm
					categories={categories}
					isCategoriesLoadin={isCategoriesLoading}
					tenderTypes={tenderTypesList}
					isTenderTypesLoading={isTenderTypesLoading}
					tenderCompanies={tenderCompanies}
					isTenderCompaniesLoading={isTenderCompaniesLoading}
					types={types}
					isTypesLoading={isTypesLoading}
					modes={modes}
					isMyCarrierSelected={isMyCarrierSelected}
					onChangeTenderType={handleChangeTenderType}
					onChangeCategory={handleChangeCategory}
					isVisibleFetchAt={isVisibleFetchAt}
				/>
			}
			footerButtons={
				<ModalFooterButtons
					rightButtons={[
						{
							onClick: handleFormSubmit,
							text: 'Создать',
							color: 'success',
							disabled: isLoading || isCategoriesLoading || isModesLoading,
							loading: isLoading,
						},
						{
							onClick: handleModalCancel,
							text: 'Отмена',
							color: 'secondary',
							disabled: isLoading,
						},
					]}
				/>
			}
		/>
	);
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(CreateReqModalWrapper);

const mapStateToProps = createStructuredSelector({
	isLoading: getIsLoadingSelector(),
	categories: getCategoriesSelector(),
	isCategoriesLoading: getIsCategoriesLoadingSelector(),
	tenderTypes: getTenderTypesSelector(),
	isTenderTypesLoading: getIsTenderTypesLoadingSelector(),
	tenderCompanies: getTenderCompaniesSelector(),
	isTenderCompaniesLoading: getIsTenderCompaniesLoadingSelector(),
	types: getTypesSelector(),
	isTypesLoading: getIsTypesLoadingSelector(),
	modes: getModesOptionsSelector(),
	isModesLoading: getIsModesLoadingSelector(),
	isMyCarrierSelected: getIsMyCarrierSelectedSelector(),
	initialValues: getFormInitialValuesSelector(),
});

const mapDispatchToProps = {
	onResetForm: reset,
	onFormSubmit: submit,
	onCreateReq: orderCreateReqAction,
	onGetCategories: getCategoriesAction,
	onGetTenderTypes: getTenderTypesAction,
	onGetTenderCompanies: getTenderCompaniesAction,
	onGetTypes: getTypesAction,
	onChangeField: change,
};

export const CreateReqModalComponent = connect(mapStateToProps, mapDispatchToProps)(withForm);

CreateReqModalWrapper.propTypes = {
	onFormSubmit: PropTypes.func.isRequired,
	onResetForm: PropTypes.func.isRequired,
	onCreateReq: PropTypes.func.isRequired,
	onGetCategories: PropTypes.func.isRequired,
	onGetTenderTypes: PropTypes.func.isRequired,
	onGetTenderCompanies: PropTypes.func.isRequired,
	onGetTypes: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
	categories: PropTypes.array,
	isCategoriesLoading: PropTypes.bool,
	tenderTypes: PropTypes.array,
	isTenderTypesLoading: PropTypes.bool.isRequired,
	tenderCompanies: PropTypes.array,
	isTenderCompaniesLoading: PropTypes.bool.isRequired,
	types: PropTypes.array,
	isTypesLoading: PropTypes.bool.isRequired,
	modes: PropTypes.array,
	isModesLoading: PropTypes.bool,
	isModalShown: PropTypes.bool,
	setIsModalShown: PropTypes.func,
	orders: PropTypes.array,
	collection: PropTypes.array,
	group: PropTypes.object,
	group_way: PropTypes.object,
	way: PropTypes.object,
	isMyCarrierSelected: PropTypes.bool.isRequired,
	onChangeField: PropTypes.func.isRequired,
};
